import React from 'react';
import { bundleCustomisationProps } from 'src/components/BundleProduct/utils/formToCustomisation';
import { ArtworkPriceBreakProps } from 'src/components/BundleProduct/BundleOptionsProvider';
import { BundleProductActions } from 'src/components/BundleProduct/BundleProductActions';
import { useVatCausesRender } from 'src/components/AppShell/VatProvider';
import { ProductPrice } from 'src/types/global-types';
import {
    sumArtworkPriceAndFee,
    RenderArtworks,
    organizeArtworkPriceInfo,
} from 'src/components/BundleProduct/ProductBundleSummary/helpers';

import { TableFoot, TableBody } from './ProductBundleSummaryElements';
import classes from './ProductBundleSummary.scss';

type ProductBundleSummaryProps = {
    setSumBundlePrice: React.Dispatch<React.SetStateAction<{ price: number; price_incl: number }>>;
    bundlePrice: ProductPrice;
    maxQty: number;
    artworkPriceBreak: ArtworkPriceBreakProps;
    artworksData: bundleCustomisationProps;
};

export const ProductBundleSummary: React.FC<ProductBundleSummaryProps> = (props) => {
    const { setSumBundlePrice, bundlePrice, artworkPriceBreak, maxQty, artworksData } = props;
    const { vat } = useVatCausesRender();
    const price = vat ? bundlePrice.price_incl : bundlePrice.price;

    return (
        <div className={classes.bundleSummary}>
            <h2 className={classes.bundleSummaryTitle}>Bundle Summary</h2>
            <table className={classes.bundleSummaryTable}>
                <thead>
                    <tr>
                        <th>Colour</th>
                        <th>Size</th>
                        <th>Quantity</th>
                    </tr>
                </thead>
                <TableBody />
                <TableFoot price={price} vat={vat} />
            </table>
            <ArtworkData
                artworkPriceBreak={artworkPriceBreak}
                setSumBundlePrice={setSumBundlePrice}
                maxQty={maxQty}
                artworksData={artworksData}
            />
        </div>
    );
};
type ArtworkDataProps = {
    artworkPriceBreak: ArtworkPriceBreakProps;
    setSumBundlePrice: React.Dispatch<React.SetStateAction<{ price: number; price_incl: number }>>;
    maxQty: number;
    artworksData: bundleCustomisationProps;
};
const ArtworkData: React.FC<ArtworkDataProps> = (props) => {
    const { artworkPriceBreak, setSumBundlePrice, maxQty, artworksData } = props;
    if (Object.keys(artworksData).length === 0) return null;
    const { artworkCost } = organizeArtworkPriceInfo({ artworkPriceBreak, artworksData, maxQty });
    const { artworksPrice, artworksFee } = sumArtworkPriceAndFee(artworkCost);
    return (
        <div className={classes.bundleArtworkWrapper}>
            <h2 className={classes.bundleSummaryTitle}>Customisations</h2>
            <div className={classes.bundleArtworkContainer}>
                <RenderArtworks position="summary" artworksData={artworksData} artworkCost={artworkCost} />
            </div>
            <BundleProductActions
                artworksData={artworksData}
                artworksPrice={artworksPrice}
                artworksFee={artworksFee}
                setSumBundlePrice={setSumBundlePrice}
            />
        </div>
    );
};
